// 个人支付模块
export default {
    Mywallet: {
        MyAccount: 'My Account',
        AvailableBalance: 'Available balance',
        RMB: 'CNY',
        Withdrawal: 'Withdrawal',
        ExpenditureAmount: 'Expenditure amount',
        TransactionRecords: 'Records',
        ApplyForInvoice: 'Invoice',
        Withdrawing: 'Withdrawing',
        BalanceWithdrawalProcess: 'Balance in the withdrawal process',
        InUse: 'In use',
        OccupationAmount: 'Amount occupied by user red envelopes, sample collection, etc',
        FunctionTemporarilyOpen: 'This function is temporarily open',
        AccountBalance: 'Account balance',
        TransactionType: 'Transaction type',
        All: 'All',
        Other: 'Other',
        TextMessage: 'Text message',
        Mail: 'Mail',
        RedEnvelope: 'Red envelope',
        Recharge: 'Recharge',
        CapitalFlow: 'Capital flow',
        Income: 'Income',
        Expenditure: 'Expenditure',
        Time: 'Time',
        TransactionName: 'Transaction Name',
        PaymentMethod: 'Payment method',
        SMSBalance: 'SMS balance',
        SMSSending: 'SMS sending',
        SMSVerification: 'SMS verification',
        SMSGift: 'SMS gift',
        SMSPurchase: 'SMS purchase',
        UsageDetails: 'Usage Details',
        SMSChangesPiece: 'SMS changes (piece)',
        SMSBalancePiece: 'SMS balance (piece)',
        ChangeType: 'Change type',
        MailBalance: 'Mail balance',
        EmailSending: 'Email sending',
        EmailGifts: 'Email Gifts',
        EmailPurchase: 'Email Purchase',
        EmailReturn: 'Email Return',
        EmailChangesPiece: 'Email changes (piece)',
        EmailBalancePiece: 'Email balance (piece)',
        Sending: 'Sending',
        Give: 'Give',
        Purchase: 'Purchase',
        TestVerify: 'Test and verify',
        Return: 'Return',
        Mailbox: 'Mailbox',
        AccountRecharge: 'Account recharge',
        RechargeAccount: 'Recharge account',
        RechargeAmount: 'Recharge amount',
        RechargeLeast10: 'Recharge at least 10',
        Alipay: 'Alipay',
        WeChat: 'WeChat',
        BankTransfer: 'Bank transfer',
        Payment: 'Pay',
        ClickPayment: 'Click on payment'
    },
  };